import script from "./PlanPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanPerformance.vue?vue&type=script&setup=true&lang=js"

import "./PlanPerformance.vue?vue&type=style&index=0&id=01f3136a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f3136a"]])

export default __exports__